import React, { useEffect, useRef } from 'react'
import AsyncSelect from 'react-select/async'

const UserMultiSelect = ({
  value,
  onChange,
  fetchUserSuggestions,
  searchUserSuggestions,
  isLoading,
  isAdmin,
  userEmail
}) => {
  const timerRef = useRef(null)
  const pendingCallbackRef = useRef(null)

  const loadOptions = (inputValue, callback) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    if (!inputValue || inputValue.length < 2) {
      callback([])
      return
    }

    pendingCallbackRef.current = callback

    timerRef.current = setTimeout(() => {
      fetchUserSuggestions(inputValue)
    }, 400)
  }

  useEffect(() => {
    if (!pendingCallbackRef.current) return

    const options = (searchUserSuggestions || [])
      .map(user => ({
        label: user.email ,
        value: user.email,
        userData: user,

        //  disable current user if admin
        // isDisabled: isAdmin && user.email === userEmail

      }))

    pendingCallbackRef.current(options)
    pendingCallbackRef.current = null
  }, [searchUserSuggestions])

  return (
    <AsyncSelect
      isMulti
      cacheOptions
      defaultOptions={false}
      loadOptions={loadOptions}
      value={value || []}
      onChange={onChange}
      isLoading={isLoading}
      placeholder="Search users..."
      
// important for disabled styling
    // isOptionDisabled={(option) => option.isDisabled}
    
    />
  )
}

export default UserMultiSelect